<template>
    <div>
        <div :class="contentClass">
            <div class="grid-content">
                <div class="grid-item grid-item-half">
                    <r-input
                        label="Percentage"
                        left-label="%"
                        v-model="value"
                        :validate="$v.min"
                        @key-submit="applyFilter"
                    />
                </div>
            </div>
            <div class="grid-content" v-if="$v.$error">
                <div class="grid-item">
                    <v-error-messages>
                        <li class="list-item" v-if="!$v.value.between ">The percentage must be between zero (0) and one hundred (100).</li>
                    </v-error-messages>
                </div>
            </div>
        </div>
        <filter-footer
            @apply-filter="applyFilter"
            @cancel-filter="cancelFilter"/>
    </div>
</template>

<script>
    import {vErrorMessages} from '@/components/form';
    import FilterFooter from '@/modules/rules-engine/components/condition-builder/filters/filter-footer';
    import BaseFilterMixin from '@/modules/rules-engine/components/condition-builder/filters/base-filter-mixin';
    import CriteriaCondition from '@/components/query/spec/criteria-condition';
    import ConditionOperators from '@/components/query/spec/condition-operators';
    import {between} from 'vuelidate/lib/validators';

    export default {
        name: 'random-filter',
        mixins: [BaseFilterMixin],
        components: {
            FilterFooter,
            vErrorMessages,
        },
        data() {
            return {
                value: this.condition.data.value,
            };
        },
        validations: {
            value: {
                between: between(0, 100),
            },
        },
        methods: {
            applyFilter() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.condition.data = new CriteriaCondition({
                        op: ConditionOperators.random,
                        value: Number(this.value),
                    });
                    this.$emit('apply-filter', {
                        index: this.index,
                        condition: this.condition,
                    });
                }
            },
        },
    };
</script>
